module.exports = __webpack_public_path__ + "static/img/activity-3.7a9ca20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity-3.png
// module id = VH0M
// module chunks = 1